import { OptionItem } from '../../../diagram/utils/option-item';
import { ConditionType } from './enum/condition-type';
var ConditionTypeHelper = /** @class */ (function () {
    function ConditionTypeHelper() {
    }
    ConditionTypeHelper.getAlarmConditionTypes = function () {
        return [
            new OptionItem(ConditionType.NotEqual, ConditionTypeHelper.getAlarmConditionName(ConditionType.NotEqual)),
            new OptionItem(ConditionType.Equal, ConditionTypeHelper.getAlarmConditionName(ConditionType.Equal)),
            new OptionItem(ConditionType.GreaterThan, ConditionTypeHelper.getAlarmConditionName(ConditionType.GreaterThan)),
            new OptionItem(ConditionType.GreaterThanEqual, ConditionTypeHelper.getAlarmConditionName(ConditionType.GreaterThanEqual)),
            new OptionItem(ConditionType.LessThan, ConditionTypeHelper.getAlarmConditionName(ConditionType.LessThan)),
            new OptionItem(ConditionType.LessThanEqual, ConditionTypeHelper.getAlarmConditionName(ConditionType.LessThanEqual))
        ];
    };
    ConditionTypeHelper.getAlarmConditionTypeRune = function () {
        return [
            new OptionItem(ConditionType.NotEqual, '≠'),
            new OptionItem(ConditionType.Equal, '='),
            new OptionItem(ConditionType.GreaterThan, '>'),
            new OptionItem(ConditionType.GreaterThanEqual, '≥'),
            new OptionItem(ConditionType.LessThan, '<'),
            new OptionItem(ConditionType.LessThanEqual, '≤')
        ];
    };
    ConditionTypeHelper.getAlarmConditionName = function (condition) {
        switch (condition) {
            case ConditionType.NotEqual:
                return 'NotEqualTo';
            case ConditionType.Equal:
                return 'EqualTo';
            case ConditionType.GreaterThan:
                return 'GreaterThan';
            case ConditionType.GreaterThanEqual:
                return 'GreaterThanOrEqualTo';
            case ConditionType.LessThan:
                return 'LessThan';
            case ConditionType.LessThanEqual:
                return 'LessThanOrEqualTo';
        }
    };
    return ConditionTypeHelper;
}());
export { ConditionTypeHelper };
